<template>
  <div class="page-container">
    <Table ref="tableRef" :params="params" :request="getData" tooltip-effect="light">
      <template #search="{query}">
        <el-form-item>
          <el-button type="primary" plain @click="exportData(query)">{{ $t('activity.packetjoin.export') }}</el-button>
        </el-form-item>
      </template>
      <el-table-column type="index" align="center" :label="$t('pages.indexNo')" width="60px" />
      <el-table-column prop="receiveTime" :label="$t('activity.packetreceive.receiveTime')" sortable="custom" />
      <el-table-column prop="userName" :label="$t('activity.packetjoin.recipient')" />
      <el-table-column prop="userId" :label="$t('activity.packetreceive.recipientId')" />
      <el-table-column prop="redAmount" :label="$t('activity.packetreceive.receiveAmt')" sortable="custom" />
      <el-table-column prop="userPhone" :label="$t('activity.packetjoin.phone')">
        <template #default="{row}">
          {{ row.userPhone &&  (String(row.userPhone).slice(0,3)+'****'+String(row.userPhone).slice(7))}}
        </template>
      </el-table-column>
      <el-table-column prop="userPhone" :label="$t('activity.packetreceive.receiveTime')" />
      <el-table-column prop="activityType" :label="$t('activity.packetreceive.paymentAct')" >
        <template #default="{row}">{{activityTypeMap[row.activityType]}}</template>
      </el-table-column>
      <el-table-column prop="orderNo" :label="$t('activity.packetjoin.paymentSerial')" />
      <el-table-column prop="robotNum" :label="$t('activity.packetjoin.robotCode')" />
      <el-table-column prop="customerName" :label="$t('activity.packetjoin.distributionStatus')" >
        <template #default="{row}">{{ packetStatusMap[row.redEnvelope] }}</template>
      </el-table-column>
      <el-table-column prop="verifyTime" :label="$t('activity.packetreceive.reviewTime')" sortable="custom" />
      <el-table-column prop="sendTime" :label="$t('activity.packetreceive.distributionTime')" sortable="custom" />
      <!-- <el-table-column prop="dataType" label="数据类型" >
        <template #default="{row}">{{ row.dataType == 1?'自动生成':'虚拟' }}</template>
      </el-table-column> -->
    </Table>
  </div>
</template>

<script>
import { reactive, toRefs } from "@vue/reactivity";
import { ElMessage, ElMessageBox } from "element-plus";
import Table from "@/components/elp/table";

import { request, downloadFile } from "@/utils/request";
import { common } from "@/common/mixin";
import { packetStatusMap } from "@/common/constant"
import { useI18n } from 'vue-i18n'
export default {
  components: {
    Table,
  },
  mixins: [common],
  setup() {
    const { t } = useI18n()
    const activityTypeList = [
      { label: t('activity.detail.newProduct'), value: 0 },
      { label: t('activity.packetjoin.registerRedPacket'), value: 1 },
    ]
    const activityTypeMap = {
      0: t('activity.detail.newProduct'),
      1: t('activity.packetjoin.registerRedPacket')
    }
    const state = reactive({
      tableRef: null,
      dialogFormVisible: false,
      detailform: {
        robotNum: '',
        cabinetNum: '',
        userId: '',
        userName: '',
        redAmount: '',
      },
      detailformRules: {},
      params: [
        {
          type: "Input",
          key: "userName",
          value: "",
          label: t('activity.packetjoin.recipient'),
        },
        {
          type: "Input",
          key: "userPhone",
          value: "",
          label: t('activity.packetjoin.phone'),
        },
        {
          type: "Select",
          key: "activityType",
          value: "",
          label: t('activity.list.actType'),
          options: {
            data: activityTypeList,
            label: "label",
            value: "value"
          }
        },
        {
          type: "Input",
          key: "robotNum",
          value: "",
          label: t('activity.packetjoin.robotCode'),
        },
        {
          type: "Date",
          key: "dateRangeReceive",
          value: [],
          label: t('activity.packetreceive.receiveTime'),
          options: {
            "type": "datetimerange",
            "format": "YYYY-MM-DD HH:mm:ss",
            "value-format": "YYYY-MM-DD HH:mm:ss",
            // "placeholder": "开始日期",
            "range-separator": t('activity.detail.to'),
            "start-placeholder": t('activity.list.startDate'),
            "end-placeholder": t('activity.list.endDate'),
            "default-time": [new Date(2000, 1, 1, 0, 0, 0), new Date(2000, 1, 1, 23, 59, 59)]
          }
        },
        {
          type: "Date",
          key: "dateRange",
          value: [],
          label: t('activity.packetreceive.reviewTime'),
          options: {
            "type": "datetimerange",
            "format": "YYYY-MM-DD HH:mm:ss",
            "value-format": "YYYY-MM-DD HH:mm:ss",
            // "placeholder": "开始日期",
            "range-separator": t('activity.detail.to'),
            "start-placeholder": t('activity.list.startDate'),
            "end-placeholder": t('activity.list.endDate'),
            "default-time": [new Date(2000, 1, 1, 0, 0, 0), new Date(2000, 1, 1, 23, 59, 59)]
          }
        },
        {
          type: "Date",
          key: "dateRangeSend",
          value: [],
          label: t('activity.packetreceive.distributionTime'),
          options: {
            "type": "datetimerange",
            "format": "YYYY-MM-DD HH:mm:ss",
            "value-format": "YYYY-MM-DD HH:mm:ss",
            // "placeholder": "开始日期",
            "range-separator": t('activity.detail.to'),
            "start-placeholder": t('activity.list.startDate'),
            "end-placeholder": t('activity.list.endDate'),
            "default-time": [new Date(2000, 1, 1, 0, 0, 0), new Date(2000, 1, 1, 23, 59, 59)]
          }
        },
        // {
        //   type: "Select",
        //   key: "dataType",
        //   value: "",
        //   label: "数据类型",
        //   options: {
        //     data: [{name: '自动生成', value: 1}, {name: '虚拟', value: 2}],
        //     label: "name",
        //     value: "value"
        //   }
        // },
      ],
      activityType: activityTypeList // 活动类型列表
    })
    const getData = (params={}) => {
      const query = {
        pageNum: params.page,
        pageSize: params.size,
      }

      // 领取时间
      if (params.dateRangeReceive?.length) {
        query.receiveStartTime = params.dateRangeReceive[0]
        query.receiveEndTime = params.dateRangeReceive[1]
      } else {
        query.receiveStartTime = undefined
        query.receiveEndTime = undefined
      }
      // 审核时间
      if (params.dateRange?.length) {
        query.startDate = params.dateRange[0]
        query.endDate = params.dateRange[1]
      } else {
        query.startDate = undefined
        query.endDate = undefined
      }
      // 发放时间
      if (params.dateRangeSend?.length) {
        query.sendStartTime = params.dateRangeSend[0]
        query.sendEndTime = params.dateRangeSend[1]
      } else {
        query.sendStartTime = undefined
        query.sendEndTime = undefined
      }
      
      return request("packetReceiveList", Object.assign(query, params));
    };
    const addNew = () => {
      state.dialogFormVisible = true
    }
    const exportData = async (params={}) => {
      try {
        const query = { ...params }
        query.page = undefined
        query.size = undefined
        // 领取时间
        if (params.dateRangeReceive?.length) {
          query.receiveStartTime = params.dateRangeReceive[0]
          query.receiveEndTime = params.dateRangeReceive[1]
        } else {
          query.receiveStartTime = undefined
          query.receiveEndTime = undefined
        }
        // 审核时间
        if (params.dateRange?.length) {
          query.startDate = params.dateRange[0]
          query.endDate = params.dateRange[1]
        } else {
          query.startDate = undefined
          query.endDate = undefined
        }
        // 发放时间
        if (params.dateRangeSend?.length) {
          query.sendStartTime = params.dateRangeSend[0]
          query.sendEndTime = params.dateRangeSend[1]
        } else {
          query.sendStartTime = undefined
          query.sendEndTime = undefined
        }
        const res = await downloadFile("exportPacketReceive", {}, {
          method: 'GET',
          params: query
        });
        // let blob = new Blob([res],{type: "application/octet-stream"})
        let reader = new FileReader();
        reader.readAsDataURL(res);
        reader.onload = (e) => {
          const a = document.createElement('a')
          a.download = t('activity.packetreceive.redPacketRecord')
          a.href = e.target.result
          a.click()
        }
      } catch (error) {
        console.error(error)
      }
    }
    const editDetail = async () => {
      state.dialogFormVisible = true
    }
    const deleteDetail = async (row) => {
      try {
        ElMessageBox({
          title: t('activity.packetreceive.prompt'),
          message: t('activity.list.confirmDelete'),
          type: 'warning',
          showCancelButton: 'true',
          confirmButtonText: t('activity.list.confirm1'),
          cancelButtonText: t('activity.list.cancel'),
        })
        await request("", {
          id: row.id
        })
        state.tableRef?.update()
        ElMessage({
          showClose: true,
          type: "success",
          message: t('activity.packetreceive.deleteSuccess')
        })
      } catch (error) {
        console.error(error);
      }
    }
    const formSubmit = async () => {
      try {
        await request("packetReceiveSave", state.detailform)
        ElMessage({
          showClose: true,
          type: "success",
          message: t('activity.packetreceive.publishSuccess')
        })
        state.dialogFormVisible = false
        state.tableRef?.update()
      } catch (error) {
        console.error(error)
      }
    }

    return {
      activityTypeMap,
      packetStatusMap,
      ...toRefs(state),
      getData,
      addNew,
      exportData,
      editDetail,
      deleteDetail,
      formSubmit
    };
  },
};
</script>

<style lang="scss" scoped>
.page-container {
  height: 100%;
  padding: 50px 10px 0;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
}
</style>
